import type { MenuItemProps } from '@affine/component';
import { MenuItem } from '@affine/component';
import { useI18n } from '@affine/i18n';
import { ShareIcon } from '@docnboard/icons/blocksuite/rc';

export const DisablePublicSharing = (props: MenuItemProps) => {
  const t = useI18n();
  return (
    <MenuItem type="danger" prefixIcon={<ShareIcon />} {...props}>
      {t['Disable Public Sharing']()}
    </MenuItem>
  );
};
